import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import enTranslation from "./locales/en.json";
import hiTranslation from "./locales/hi.json";


i18n
  .use(LanguageDetector) // Detect language based on browser settings
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      hi: { translation: hiTranslation },
    },
    fallbackLng: "hi", // Default language when no language match is found
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator", "cookie", "htmlTag"], // Check the preferred language in localStorage first
      caches: ["localStorage"], // Cache the selected language in localStorage
    }
  });
if (i18n?.language?.match(/^en-[A-Z]{2}$/)) {
  i18n.changeLanguage('en')
}
export default i18n;
